import React from 'react';
import VerifiedFlame from '../VerifiedFlame';
import { buildMeasurableGroups } from '../../lib/publicProfile';

export default function Measurables({ athlete, catalog }) {
  const groups = buildMeasurableGroups(athlete, catalog);
  if (groups.length === 0) return null;

  return (
    <section>
      <div className="ed-cap">
        <span className="ed-cap__label">Verified Measurables</span>
        <span className="ed-cap__hint ed-pp__legend">
          <VerifiedFlame size={13} /> = measured &amp; verified by ProZpects
        </span>
      </div>

      <div className="ed-pp__groups">
        {groups.map(g => (
          <div key={g.title} className="ed-pp__card">
            <div className="ed-pp__group-head">
              <span className="ed-pp__group-title">{g.title}</span>
              <span className="ed-pp__group-hint">{g.hint}</span>
            </div>
            {g.rows.map(r => (
              <div key={r.key} className="ed-pp__row">
                <span className="ed-pp__row-label">{r.label}</span>
                <span className="ed-pp__row-value">{r.value}</span>
                <span className="ed-pp__row-badge">{r.verified && <VerifiedFlame size={16} />}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
